import React from 'react';
import { Rating, Box } from '@mui/material';
import StarIcon from '@mui/icons-material/Star';
import Api from '../../Api.js'
const customIcons = {
    4: {
        icon: <StarIcon />,
        label: 'Satisfied',
    },
};

/**
 * @param {Object} props
 * @param {boolean} props.disabled
 * @param {number} props.defaultValue
 * @param {string|number} props.task
 * @param {string|number} props.manager
 * @param {string|number} props.taskManager
 * @param {function} props.getData
 */
const CustomizedRatings = ({disabled=true, defaultValue, task, manager, taskManager, getData}) => {
    

    return (
        <Box component="fieldset" mb={3} borderColor="transparent">
            <Rating
                disabled={disabled}
                name="customized-10"
                defaultValue={defaultValue}
                max={5}
                precision={0.5}
                value={defaultValue}
                icon={customIcons[4].icon}
            />
        </Box>
    );
};

export default CustomizedRatings;
